import Vue from 'vue'
import echarts from 'echarts'

Object.defineProperty(Vue.prototype, '$echarts', { value: echarts })